import { TourProvider } from "@reactour/tour";

interface TourProviderProps {
	children: React.ReactNode;
}
export function ClusterTourProvider(props: TourProviderProps) {
	return (
		<TourProvider
			steps={[]}
			showNavigation={true}
			showPrevNextButtons={true}
			showCloseButton={true}
			disableDotsNavigation={false}
			onClickMask={() => {}} // Prevent closing the tour when clicking on the mask
			styles={{
				maskWrapper: (base) => ({
					...base,
					color: "rgba(0, 0, 0, 0.5)",
				}),

				popover: (base) => ({
					...base,
					maxWidth: "400px",
				}),
				badge: () => ({
					display: "none", // Hide the badge
				}),
				maskArea: (base) => ({
					...base,
					color: "rgba(0, 0, 0, 0.5)",
				}),
				// masksWrapper: (base) => ({
				// 	...base,
				// 	color: "rgba(0, 0, 0, 0.5)",
				// }),
				// maskRect: (base) => ({
				// 	...base,
				// 	backgroundColor: "rgba(0, 0, 0, 0.5)",
				// }),
				// controls: (base) => ({
				// 	...base,
				// 	marginTop: "15px",
				// 	display: "flex",
				// 	justifyContent: "space-between",
				// 	alignItems: "center",
				// }),
				// close: (base) => ({
				// 	...base,
				// 	right: "12px",
				// 	top: "12px",
				// 	fontSize: "20px",
				// 	color: "#666",
				// 	zIndex: 10001,
				// }),
			}}
		>
			{props.children}
		</TourProvider>
	);
}

export interface TourInstanceProps {
	children: React.ReactNode;
}
